import { createFileRoute } from "@tanstack/react-router";
import PartsAccountVerify from "@/pages/parts-account/PartsAccountVerify";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/account/verify")({
  head: () => { const h = pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/parts-catalog/account/verify' }); h.meta.push({ name: "robots", content: "noindex, follow" }); return h; },
  component: PartsAccountVerify,
});
